import { useEffect, useState } from "react";
import { api, formatUSD, PHOTO_CATEGORIES } from "../lib/api";
import { PhotoCard } from "../components/PhotoCard";
import { PrintOrderModal } from "../components/PrintOrderModal";
import { TimelapseCard } from "../components/TimelapseCard";

export default function Shop() {
  const [tab, setTab] = useState("prints");
  const [photos, setPhotos] = useState([]);
  const [timelapses, setTimelapses] = useState([]);
  const [catalog, setCatalog] = useState(null);
  const [ctx, setCtx] = useState(null);
  const [cat, setCat] = useState("All");

  useEffect(() => {
    document.title = "Shop — Prints & Licenses — Scott Burton Photography";
    api.get("/timelapses").then(({ data }) => setTimelapses(data));
    api.get("/pricing").then(({ data }) => setCatalog(data));
  }, []);
  useEffect(() => {
    const params = { for_sale: true };
    if (cat !== "All") params.category = cat;
    api.get("/photos", { params }).then(({ data }) => setPhotos(data));
  }, [cat]);

  const buy = (photo) => setCtx({
    kind: "photo", title: photo.title, photoId: photo.id, imageUrl: photo.image_url,
  });

  return (
    <div className="max-w-7xl mx-auto px-6 lg:px-10 pt-28 pb-24">
      <div className="overline-label mb-3">Shop</div>
      <h1 className="font-serif text-5xl lg:text-6xl font-light">Prints & Licenses</h1>

      <div className="mt-8 flex gap-2 border-b border-white/10">
        {[["prints", "Fine-Art Prints"], ["licenses", "Video Licenses"]].map(([k, label]) => (
          <button key={k} data-testid={`shop-tab-${k}`} onClick={() => setTab(k)}
            className={`px-5 py-3 text-sm -mb-px border-b-2 transition-colors ${
              tab === k ? "border-amber-glow text-amber-glow" : "border-transparent text-neutral-400 hover:text-white"
            }`}>
            {label}
          </button>
        ))}
      </div>

      {tab === "prints" && (
        <>
          <div className="mt-6 flex flex-wrap gap-2">
            {PHOTO_CATEGORIES.filter((c) => c !== "Wedding").map((c) => (
              <button key={c} data-testid={`shop-cat-${c}`} onClick={() => setCat(c)}
                className={`px-4 py-1.5 rounded-full text-sm border transition-colors ${
                  cat === c ? "border-amber-glow text-amber-glow bg-amber-glow/10" : "border-white/12 text-neutral-300 hover:border-white/30"
                }`}>
                {c}
              </button>
            ))}
          </div>
          <div className="mt-8 grid gap-6 sm:grid-cols-2 lg:grid-cols-4">
            {photos.map((p, i) => <PhotoCard key={p.id} photo={p} index={i} onBuy={buy} />)}
          </div>
        </>
      )}

      {tab === "licenses" && (
        <div className="mt-10">
          <p className="text-neutral-400 max-w-2xl mb-8">
            License any sequence for commercial or personal use. Choose your license on each film's page.
          </p>
          <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-3">
            {timelapses.map((tl, i) => (
              <div key={tl.id}>
                <TimelapseCard tl={tl} index={i} />
                <div className="flex justify-between text-xs text-neutral-400 mt-2 px-1">
                  <span>Personal {formatUSD(tl.personal_price)}</span>
                  <span>Commercial {formatUSD(tl.commercial_price)}</span>
                </div>
              </div>
            ))}
          </div>
        </div>
      )}

      <PrintOrderModal open={!!ctx} onClose={() => setCtx(null)} catalog={catalog} context={ctx} />
    </div>
  );
}
